var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"loading":"lazy","width":"100%","height":"100%","src":_vm.option.attribute.url}})}
var staticRenderFns = []

export { render, staticRenderFns }